<template>
  <div class="report">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <!-- <div class="return clearfix">
          <img src="../assets/img/返回.png" alt />
          返回课程
        </div>-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :replace="true" to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>报告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_l">
          <div class="content_box_l_title">答题卡</div>
          <!-- 答题卡 -->
          <div class="topic_card">
            <div class="card_alt clearfix">
              <div class="card_alt_item clearfix">
                <span class="lv"></span>正确
              </div>
              <div class="card_alt_item">
                <span class="red"></span>错误
              </div>
              <div class="card_alt_item">
                <span></span>未答
              </div>
            </div>
            <div class="topic_card_item" v-for="(item,index) in detail.questionTypes" :key="index">
              <div class="card_item_title">{{item.type_name}}</div>
              <div class="card_box clearfix">
                <div
                  class="number_list"
                  :class="item1.userAnswer=='-'?'bai':item1.userAnswer==item1.answer?'lv':'red'"
                  v-for="(item1,index) in item.questions"
                  :key="index"
                  @click="report_click(item1.i)"
                >{{item1.i}}</div>
              </div>
            </div>

            <div class="new_make huang" @click="again_click">重做</div>
          </div>
        </div>
        <div class="content_box_r">
          <div class="report_data clearfix">
            <!-- <div class="fraction">
              <span>{{detail.score}}</span>
              分
            </div> -->
            <div class="fraction">
                <el-progress type="circle" :percentage="detail.score" color="#FADA1E" :format="textM"></el-progress>
            </div>
            <div class="tag_item">
              <div class="tag_item_title">知识点掌握率</div>
              <div class="tag_item_content">{{detail.knowledgeRate}}%</div>
            </div>
            <div class="tag_item">
              <div class="tag_item_title">正确率</div>
              <div class="tag_item_content">{{Correct_rate}}%</div>
            </div>
            <div class="tag_item">
              <div class="tag_item_title">错题数</div>
              <div class="tag_item_content">
                <span>{{detail.wrong_count}}</span>
                /{{detail.total_item_count}}
              </div>
            </div>
            <div class="tag_item">
              <div class="tag_item_title">用时</div>
              <div class="tag_item_content">
                {{timer}}
              </div>
            </div>
          </div>
          
          <div class="powerChange">
              <div class="top">
                  <div class="left">
                    <img src="../assets/img/icon1.png" alt="" style="width:30px;margin-right:8px">能力变化
                  </div>
                  <div class="right" @click="isShowPower=!isShowPower">
                    <span v-if="!isShowPower">展开</span>
                    <span v-else>收起</span>
                    <img src="../assets/img/up1.png" v-if="isShowPower" alt="" style="width:30px;margin-left:16px">
                    <img src="../assets/img/down1.png" v-else alt="" style="width:30px;margin-left:16px">
                  </div>
              </div>
              <!-- 458px -->
              <div class="changeBox" :style="{height:isShowPower?'458px':'0px'}">
                  <div class="title">能力变化</div>

                  <div class="positionBox">
                    <div class="block" v-for="(item,index) in detail.ability" :key="index">
                      <p>{{item.name}}</p>
                      <div class="zw">{{item.old_known_rate}}%<span>→</span>{{item.new_known_rate}}%</div>
                      <div class="progress">
                        <div class="gray"></div>
                        <div class="yellow1" :style="{width:item.old_known_rate+'%'}"></div>
                        <div class="yellow2" :style="{width:(item.new_known_rate-item.old_known_rate)+'%',left:item.old_known_rate+'%'}"></div>
                      </div>
                    </div>

                    
                  </div>


                  
              </div>
          </div>

          <div class="adImg" @click="adClick(adInfo.link)" v-if="adInfo"><img :src="adInfo.content" alt="" style="margin-bottom:24px;cursor:pointer"></div>


          <div class="work_box">
            <!-- 题 -->
            <div
              class="work_box_content"
              v-for="(item,index) in wrong_list"
              :key="index"
              v-show="current_index ==index"
            >
              <!-- 单选题 -->
              <div class="topic_box" v-if="item.question_type ==1">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <!-- <div class="work_name">{{item.stem}}</div> -->
                  <div class="work_name" v-html="item.stem"></div>
                  <div class="answer">
                    <div class="answer_list clearfix" v-for="(item1,i) in item.metas" :key="i">
                      <span
                        :class="answer_state_list[index][i]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-if="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>
                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <div class="btn" v-if="URL_MAQIN==2&&!btn_show" @click="btn_click_kjc">发起提问</div>
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
              </div>
              <!-- 多选 -->
              <div class="topic_box" v-if="item.question_type ==2">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <!-- <div class="work_name">{{item.stem}}</div> -->
                  <div class="work_name" v-html="item.stem"></div>
                  <div class="answer">
                    <div class="answer_list clearfix" v-for="(item1,i) in item.metas" :key="i">
                      <span
                        :class="[active_list[index][i], answer_state_list[index][i]] "
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-if="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>
                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <div class="btn" v-if="URL_MAQIN==2&&!btn_show" @click="btn_click_kjc">发起提问</div>
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
              </div>
              <!-- 判断 -->
              <div class="topic_box" v-if="item.question_type ==3">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <!-- <div class="work_name">{{item.stem}}</div> -->
                  <div class="work_name" v-html="item.stem"></div>
                  <div class="answer">
                    <div class="answer_list clearfix" v-for="(item1,i) in item.metas" :key="i">
                      <span
                        :class="answer_state_list[index][i]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-if="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>
                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <div class="btn" v-if="URL_MAQIN==2&&!btn_show" @click="btn_click_kjc">发起提问</div>
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
              </div>
              <!-- 不定项 -->
              <div class="topic_box" v-if="item.question_type ==4">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <!-- <div class="work_name">{{item.stem}}</div> -->
                  <div class="work_name" v-html="item.stem"></div>
                  <div class="answer">
                    <div class="answer_list clearfix" v-for="(item1,i) in item.metas" :key="i">
                      <span
                        :class="answer_state_list[index][i]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-if="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>
                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <div class="btn" v-if="URL_MAQIN==2&&!btn_show" @click="btn_click_kjc">发起提问</div>
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
              </div>
              <!-- 简答 -->
              <div class="topic_box" v-if="item.question_type >4">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <!-- <div class="work_name">{{item.stem}}</div> -->
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <el-input
                      type="textarea"
                      :rows="4"
                      :placeholder="item.userAnswer"
                      resize="none"
                      @input="input_value"
                      @blur="input_blur(index,item)"
                      v-model="value"
                      :readonly="answer_state_list[index][1]"
                    ></el-input>
                    <!-- <div class="answer_div" v-html="item.userAnswer"></div> -->
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                  </div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-if="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <div class="trueanswer">
                      <span>答案：</span>
                      <div class="analysis_c_box" v-html="item.trueAnswer"></div>
                    </div>
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>
                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <div class="btn" v-if="URL_MAQIN==2&&!btn_show" @click="btn_click_kjc">发起提问</div>
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ExamResult,
  Favorite,
  SaveComment,
  SaveFavorite,
  Crumbs,
  billing
} from "@/api/index";
import appConfig from '@/api/appConfig';
export default {
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      textarea_ans: "", //用户输入答案
      textarea: "", //提问输入\
      detail: {}, //数据
      Correct_rate: 0, //正确率
      exam: "",
      value: "",
      chapter_id: "", //知识点id
      btn_show: true, //提问按钮变化
      analysis_show: false, //解析的显示隐藏
      analysis_value: "查看",
      length: "",
      Jump_index: 0, //跳转的index
      wrong_list: [], //题目列表
      answer_state_list: [], //二维数组
      current_index: 0, //当前题目下标
      answer_state_lock: [], //记录题目是否已答
      error_list: [], //记录解每道题解析是否显示
      more_list: [], //记录多选题确定按钮的显示隐藏
      moreArr: [], //
      active_list: [], //多选题选中时数组,
      questionTypes: [], //答题卡,
      sum: 0,
      err_or_true_list: [], //判断答题卡是否对错
      title: "",
      adInfo:'',
      isShowPower:false,
    };
  },
  async mounted() {
    this.$utils.banCopy()
    if (this.$route.query.exam) {
      this.exam = this.$route.query.exam;
    } else {
      this.exam = "";
    }
    if (this.$route.query.id) {
      let obj = {};
      obj.result_id = this.$route.query.id;
      await this.examResult(obj);
    } else {
      let obj1 = {};
      obj1.test_id = this.$route.query.test_id;
      await this.examResult(obj1);
    }
    



    
  },
  computed:{
    timer(){
      let runTime = this.detail.end_time - this.detail.begin_time
      var year = Math.floor(runTime / 86400 / 365);
      runTime = runTime % (86400 * 365);
      var month = Math.floor(runTime / 86400 / 30);
      runTime = runTime % (86400 * 30);
      var day = Math.floor(runTime / 86400);
      runTime = runTime % 86400;

      var hour = Math.floor(runTime / 3600)==0?'00':Math.floor(runTime / 3600);
      runTime = runTime % 3600;
      var minute = Math.floor(runTime / 60)==0?'00':Math.floor(runTime / 60);
      runTime = runTime % 60<10?'0'+(runTime % 60):runTime % 60;
      var second = runTime;

      let long = `${hour}:${minute}:${second}`
      return long
    }
  },
  methods: {
    textM(percentage){
        return percentage+'分'
    },
    examResult(obj) {
      ExamResult(obj).then(res => {
        // console.log(res);
        this.detail = res;
        this.Correct_rate = (
          (parseInt(res.right_item_count) / parseInt(res.total_item_count)) *
          100
        ).toFixed(0);
        this.wrong_list = res.questions;
        this.length = res.questions.length;
        this.questionTypes = res.questionTypes;
        this.title = res.paper_name;
        // console.log(this.wrong_list);
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = true;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
        for (let i = 0; i < this.wrong_list.length; i++) {
          if (this.wrong_list[i].userAnswer) {
            this.answer_state_lock[i] = true;
            if (
              this.wrong_list[i].question_type == 1 ||
              this.wrong_list[i].question_type == 3
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-right"
                    );
                    this.$set(this.err_or_true_list, i, true);
                  }
                }
              } else {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].trueAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-none"
                    );
                    this.$set(this.err_or_true_list, i, false);
                  }
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-error"
                    );
                  }
                }
              }
            } else if (
              this.wrong_list[i].question_type == 2 ||
              this.wrong_list[i].question_type == 4
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                // console.log(77777);
                let arr = this.wrong_list[i].trueAnswer.split("");
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-right"
                      );
                      this.$set(this.err_or_true_list, i, true);
                    }
                  }
                }
              } else {
                let arr = this.wrong_list[i].userAnswer.split("");
                let arr1 = this.wrong_list[i].trueAnswer.split("");
                console.log(arr, "用户");
                console.log(arr1, "答案");

                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr1.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr1[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-none"
                      );
                    }
                  }
                  for (let k = 0; k < arr.length; k++) {
                    for (let m = 0; m < arr1.length; m++) {
                      this.$set(this.err_or_true_list, i, false);
                      if (arr[k] == arr1[m]) {
                        console.log(arr[k], "正确");
                        let tag = 0;
                        if (arr[k] == "A") {
                          tag = 0;
                        } else if (arr[k] == "B") {
                          tag = 1;
                        } else if (arr[k] == "C") {
                          tag = 2;
                        } else if (arr[k] == "D") {
                          tag = 3;
                        }
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          tag,
                          "answer-right"
                        );
                      } else if (
                        this.wrong_list[i].metas[j].key == arr[k] &&
                        arr[k] !== arr1[m]
                      ) {
                        console.log(arr[k]);
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          j,
                          "answer-error"
                        );
                      }
                    }
                  }
                }
              }
            } else {
              this.changeArrValue(
                this.answer_state_list,
                i,
                0,
                this.wrong_list[i].userAnswer
              );
              this.changeArrValue(this.answer_state_list, i, 1, true);
              this.$set(this.err_or_true_list, i, true);
            }
          }
        }
        this.getbilling(33,this.detail.course_id)
      });
    },
    examResult1(obj) {
      ExamResult(obj).then(res => {
        console.log(res);
        this.detail = res;
        this.Correct_rate = (
          (parseInt(res.right_item_count) / parseInt(res.total_item_count)) *
          100
        ).toFixed(0);
        this.wrong_list = res.data.questions;
        this.length = res.questions.length;
        this.questionTypes = res.questionTypes;
        this.title = res.paper_name;
        console.log(res);
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = true;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
        for (let i = 0; i < this.wrong_list.length; i++) {
          if (this.wrong_list[i].userAnswer) {
            this.answer_state_lock[i] = true;
            if (
              this.wrong_list[i].question_type == 1 ||
              this.wrong_list[i].question_type == 3
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-right"
                    );
                    this.$set(this.err_or_true_list, i, true);
                  }
                }
              } else {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].trueAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-none"
                    );
                    this.$set(this.err_or_true_list, i, false);
                  }
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-error"
                    );
                  }
                }
              }
            } else if (
              this.wrong_list[i].question_type == 2 ||
              this.wrong_list[i].question_type == 4
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                // console.log(77777);
                let arr = this.wrong_list[i].trueAnswer.split("");
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-right"
                      );
                      this.$set(this.err_or_true_list, i, true);
                    }
                  }
                }
              } else {
                let arr = this.wrong_list[i].userAnswer.split("");
                let arr1 = this.wrong_list[i].trueAnswer.split("");
                console.log(arr, "用户");
                console.log(arr1, "答案");

                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr1.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr1[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-none"
                      );
                    }
                  }
                  for (let k = 0; k < arr.length; k++) {
                    for (let m = 0; m < arr1.length; m++) {
                      this.$set(this.err_or_true_list, i, false);
                      if (arr[k] == arr1[m]) {
                        console.log(arr[k], "正确");
                        let tag = 0;
                        if (arr[k] == "A") {
                          tag = 0;
                        } else if (arr[k] == "B") {
                          tag = 1;
                        } else if (arr[k] == "C") {
                          tag = 2;
                        } else if (arr[k] == "D") {
                          tag = 3;
                        }
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          tag,
                          "answer-right"
                        );
                      } else if (
                        this.wrong_list[i].metas[j].key == arr[k] &&
                        arr[k] !== arr1[m]
                      ) {
                        console.log(arr[k]);
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          j,
                          "answer-error"
                        );
                      }
                    }
                  }
                }
              }
            } else {
              this.changeArrValue(
                this.answer_state_list,
                i,
                0,
                this.wrong_list[i].userAnswer
              );
              this.changeArrValue(this.answer_state_list, i, 1, true);
              this.$set(this.err_or_true_list, i, true);
            }
          }
        }
        this.getbilling(33,this.detail.course_id)
      });
    },
    // again_click(course_id, test_id) {
    //   this.$router.go(-1);
    // },
    favorite(id) {
      Favorite(id).then(res => {
        this.wrong_list = res.questionList;
        this.length = res.count;
        this.questionTypes = res.questionTypes;
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = false;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
      });
    },
    saveComment(obj) {
      SaveComment(obj).then(res => {
        console.log(res);
        this.value = "";
        this.btn_show = true;
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success"
          });
        } else {
          this.$message.error(res.data.data);
        }
      });
    },

    saveFavorite(id) {
      SaveFavorite(id).then(res => {
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success"
          });
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    changeArrValue(arr, index, jndex, value) {
      let array = arr[index];
      array[jndex] = value;
      arr.splice(index, 1, array);
      // console.log(this.answer_state_list);
    },
    change_active_list(arr, index, jndex, value) {
      let array = arr[index];
      array[jndex] = value;
      arr.splice(index, 1, array);
      // console.log(666);
    },

    input_c(value) {
      if (value) {
        this.btn_show = false;
      } else {
        this.btn_show = true;
      }
    },
    adClick(url){
      // window.location.href = url;
      window.open(url)
    },
    btn_click() {
      window.open(`${appConfig.ShoppUrl}ask/related${this.wrong_list[this.current_index].question_id}`);
    },
    btn_click_kjc() {
      console.log(this.value);
      let commObj = {};
      commObj.source_id = this.wrong_list[this.current_index].id;
      commObj.source_type = "question";
      commObj.content = this.value;
      this.saveComment(commObj);
      console.log(this.wrong_list[this.current_index])
    },

    // 点击解析显示隐藏
    analysis_click() {
      this.$set(
        this.error_list,
        this.current_index,
        !this.error_list[this.current_index]
      ); // 改变数组 直接改变数组视图无法更新
    },
    // 点击收藏
    collection_click() {
      if (this.wrong_list[this.current_index].is_favorite == 1) {
        this.wrong_list[this.current_index].is_favorite = 0;
      } else {
        this.wrong_list[this.current_index].is_favorite = 1;
      }
      this.saveFavorite(this.wrong_list[this.current_index].question_id);
    },
    car_click() {
      this.show = true;
      for (let i = 0; i < this.err_or_true_list.length; i++) {
        if (this.err_or_true_list[i] != "h") {
          this.Again_show = true;
        }
      }
    },

    // 点击答题卡序号
    report_click(i) {
      this.Jump_index = i - 1;
      this.current_index = i - 1;
      this.show = false;
      this.sum = 0;
      if (this.sum >= 2) {
        this.$set(this.more_list, this.current_index, true);
      } else {
        this.$set(this.more_list, this.current_index, false);
      }
    },
    // 简答题
    input_blur(index, item) {
      console.log(this.answer_state_list);
      this.changeArrValue(
        this.answer_state_list,
        this.current_index,
        0,
        this.value1
      );
      this.changeArrValue(this.answer_state_list, this.current_index, 1, true);
      this.answer_state_lock[this.current_index] = true;
    },
    input_value(value) {
      // console.log(value);
      this.value1 = value;
    },
    up_click() {
      if (this.current_index == 0) {
        this.$message({
          showClose: true,
          message: "已经是第一题了哦",
          type: "warning"
        });
      } else {
        this.current_index -= 1;
        this.moreArr = [];
        this.sum = 0;
      }
      this.value = "";
    },
    next_click() {
      if (this.current_index == this.answer_state_list.length - 1) {
        this.$message({
          showClose: true,
          message: "最后一题了",
          type: "warning"
        });
      } else {
        this.current_index += 1;
        this.moreArr = [];
        this.sum = 0;
      }
      this.value = "";
    },
    // 点击解析显示隐藏
    analysis_click() {
      this.$set(
        this.error_list,
        this.current_index,
        !this.error_list[this.current_index]
      ); // 改变数组 直接改变数组视图无法更新
    },
    // 点击收藏
    collection_click() {
      if (this.wrong_list[this.current_index].is_favorite == 1) {
        this.wrong_list[this.current_index].is_favorite = 0;
      } else {
        this.wrong_list[this.current_index].is_favorite = 1;
      }
      this.saveFavorite(this.wrong_list[this.current_index].question_id);
    },
    again_click() {
      this.$router.go(-1);
    },
    // 广告
    getbilling(id,course_id){
      billing(id,course_id).then(res=>{
        if(res.length>0)
          this.adInfo=res[0]
      })
    },
    
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 44px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 422px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .topic_card {
        padding: 0 42px;
        .card_alt {
          padding-bottom: 21px;
          border-bottom: 1px solid #eee;
          margin-bottom: 34px;
          .card_alt_item {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 12px;
            margin-right: 18px;
            span {
              float: left;
              display: block;
              width: 12px;
              height: 12px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(204, 204, 204, 1);
              border-radius: 50%;
              margin-right: 5px;
            }
            .red {
              background: rgba(232, 66, 51, 0.2);
              border: 1px solid rgba(232, 66, 51, 1);
            }
            .lv {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
            }
          }
        }
        .topic_card_item {
          margin-bottom: 34px;
          .card_item_title {
            font-size: 16px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 21px;
          }
          .card_box {
            border-bottom: 1px solid #eee;
            .number_list {
              float: left;
              width: 34px;
              height: 34px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(204, 204, 204, 1);
              font-size: 14px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              text-align: center;
              line-height: 34px;
              border-radius: 50%;
              margin-right: 35px;
              margin-bottom: 20px;
              &:nth-of-type(5n) {
                margin-right: 0;
              }
            }
            .lv {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
              color: rgba(12, 213, 109, 1);
            }
            .red {
              background: rgba(232, 66, 51, 0.2);
              border: 1px solid rgba(232, 66, 51, 1);
              color: rgba(232, 66, 51, 1);
            }
          }
        }
        .new_make {
          cursor: pointer;
          width: 258px;
          height: 37px;
          background: rgba(238, 238, 238, 0.6);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          line-height: 37px;
          margin: 0 auto 50px auto;
        }
        .huang {
          background-color: #fadc1e;
        }
      }
    }
    .content_box_r {
      float: right;
      width: 913px;
      .report_data {
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        padding: 21px 0 21px 53px;
        background-color: #fff;
        margin-bottom: 24px;
        .fraction {
          float: left;
          font-size: 18px;
          font-weight: 500;
          color: rgba(136, 136, 136, 1);
          span {
            font-size: 60px;
            font-weight: 500;
            color: rgba(250, 52, 119, 1);
          }
        }
        .tag_item {
          float: left;
          margin-left: 47px;
          .tag_item_title {
            font-size: 16px;
            font-weight: 500;
            color: rgba(182, 183, 184, 1);
            margin-bottom: 27px;
            text-align: center;
          }
          .tag_item_content {
            font-size: 18px;
            font-weight: 500;
            color: rgba(61, 68, 77, 1);
            text-align: center;
            span {
              color: #fb5070;
            }
          }
        }
      }
      .powerChange{
        position: relative;
        .top{
          background: #FADA1E;
          height: 66px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 50px;
          .left,.right{
            display: flex;
            align-items: center;
          }
          .left{
            font-size: 20px;
          }
          .right{
            font-size: 18px;
            cursor: pointer;
          }
        }
        .changeBox{
          box-sizing: border-box;
          position: absolute;
          // padding: 30px 50px;
          overflow: hidden;
          transition: all .5s;
          width: 100%;
          z-index: 2;
          background: #FFFFFF;
          box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
          border: 1px solid #E6E6E6;
          overflow-y: auto;
          .title{
            padding-top: 30px;
            margin-left: 50px;
            font-size: 19px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            position: relative;
            &:before{
              background: #FADA1E;
              width: 76px;
              height: 8px;
              position: absolute;
              bottom: -10px;
              left: 0;
              content: '';
            }
          }
          .positionBox{
            overflow: hidden;
            .block{
              width: 50%;
              float: left;
              padding-left: 50px;
              box-sizing: border-box;
              &:last-of-type{
                margin-bottom: 30px;
              }
              p{
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #333333;
                margin-top: 30px;
              }
              .zw{
                font-size: 14px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #000000;
                margin-top: 14px;
                span{
                  color: #0091FF !important;
                }
              }
              .progress{
                margin-top: 10px;
                position: relative;
                width: 312px;
                height: 20px;
                .gray{
                  width: 100%;
                  height: 100%;
                  background: #F1F1F1;
                  border-radius: 7px;
                }
                .yellow1{
                  background: #F7E789;
                  border-radius: 12px 0px 0px 12px;
                  position: absolute;
                  left: 0;
                  top: 0;
                  height: 100%;
                }
                .yellow2{
                  background: #FADA1E;
                  position: absolute;
                  top: 0;
                  height: 100%;
                }
              }
            }
          }
          
        }

      }
      .work_box {
        border: 1px solid rgba(238, 238, 238, 1);
        padding: 0 50px 80px 50px;
        background-color: #fff;
        .work_box_title {
          padding: 21px 0;
          border-bottom: 1px solid #eee;
          .name {
            cursor: pointer;
            float: left;
            position: relative;
            margin-right: 32px;
            .name_c {
              border-bottom: 1px solid #eee;
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              z-index: 999;
            }
            span {
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              display: block;
              height: 12px;
              background: rgba(250, 220, 30, 1);
            }
          }
        }
        .work_box_content {
          padding: 24px 30px 0 30px;

          .topic_top {
            font-size: 20px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 32px;
            .number {
              float: left;
              span {
                font-size: 25px;
                color: rgba(255, 0, 54, 1);
              }
            }
            .type {
              float: left;
              margin-left: 19px;
              line-height: 36px;
            }
          }
          .topic_bottom {
            // border-bottom: 1px solid #eee;
            margin-bottom: 32px;
            .work_name {
              // width: 587px;
              font-size: 18px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 40px;
            }
            .answer {
              .answer_list {
                line-height: 32px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                margin-bottom: 42px;
                span {
                  cursor: pointer;
                  float: left;
                  width: 34px;
                  height: 34px;
                  background: rgba(255, 255, 255, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  text-align: center;
                  line-height: 34px;
                  border-radius: 50%;
                  margin-right: 24px;
                }
                .answer-right {
                  background: rgba(12, 213, 109, 0.2) !important;
                  border: 2px solid rgba(12, 213, 109, 1) !important;
                  color: #0cd56d !important;
                }
                .answer-error {
                  background: rgba(232, 66, 51, 0.2) !important;
                  border: 2px solid rgba(232, 66, 51, 1) !important ;
                  color: rgba(232, 66, 51, 1) !important;
                }
                .answer-none {
                  background: rgba(12, 213, 109, 0.2) !important;
                  border: 2px solid rgba(12, 213, 109, 1) !important;
                  color: #0cd56d;
                }
                .more {
                  border-radius: 4px;
                }
                .work_key{
                  white-space: pre-wrap;
                }
              }
              .el-textarea {
                width: 587px;
                margin-bottom: 50px;
              }
              .answer_div {
                width: 587px;
                margin-bottom: 50px;
                border-radius: 3px;
                background: rgba(249, 249, 249, 1);
                border: 1px solid rgba(238, 238, 238, 1);
                padding: 30px 20px;
              }
            }
          }
          .yida{
              display: flex;
              padding-bottom: 52px;
              padding-top: 20px;
              >div{
                margin-left: 30px;
                border-radius: 23px;
                font-size: 12px;
                font-weight: 500;
                color: #333333;
                padding: 8px 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:first-of-type{
                  margin-left: 0;
                }
                span{
                  margin-left: 16px;
                  font-size: 16px;
                  font-weight: 600;
                  color: #1FD6A8;
                }
              }
            }
          .certain {
            .certain_btn {
              cursor: pointer;
              margin: auto;
              width: 258px;
              height: 37px;
              background: rgba(238, 238, 238, 0.6);
              border-radius: 4px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              text-align: center;
              line-height: 37px;
            }
            .huang {
              background-color: #fadc1e;
              color: #333;
            }
          }
          // 解析
          .min_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 33px;
            span {
              display: block;
              float: left;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              margin-right: 16px;
            }
          }
          .resolve {
            .trueanswer {
              font-size: 16px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 26px;
              span {
                font-size: 18px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
          .alt {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 24px;
          }
          .textarea_box {
            .btn {
              cursor: pointer;
              float: right;
              width: 85px;
              height: 33px;
              background: rgba(250, 220, 30, 1);
              border-radius: 4px;
              margin-top: 16px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
              text-align: center;
              line-height: 33px;
            }
          }
          .operate_box {
            padding-bottom: 80px;
            border-bottom: 1px solid #eee;
            margin-bottom: 27px;
            .operate_box_l {
              float: left;
              .up,
              .next {
                cursor: pointer;
                float: left;
                width: 73px;
                height: 31px;
                background: rgba(0, 69, 96, 0.04);
                border: 1px solid rgba(238, 238, 238, 1);
                font-size: 16px;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                text-align: center;
                line-height: 31px;
              }
              .next {
                margin-left: 42px;
              }
              .hui {
                border: 1px solid rgba(238, 238, 238, 1);
                background: rgba(238, 238, 238, 1);
                color: rgba(153, 153, 153, 1);
              }
            }
            .operate_box_r {
              float: right;
              .faver,
              .show_resolve {
                cursor: pointer;
                float: left;
                background: rgba(0, 69, 96, 0.04);
                border-radius: 4px;
                border: 1px solid rgba(238, 238, 238, 1);
                padding: 7px 12px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                img {
                  float: left;
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                }
              }
              .show_resolve {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.el-breadcrumb__inner.is-link {
  font-weight: 500;
}
.el-breadcrumb__inner.is-link:hover {
  color: #333;
}
.el-textarea__inner {
  background-color: #eeeeee;
  border: 1px solid #eee;
}
</style>